import React from 'react'

function FullStack() {
  return (
    <div>
        <div className="container mx-auto px-4 py-24">
      <div className="bg-white shadow-lg rounded-lg p-8">
        <h1 className="text-3xl font-bold text-center mb-4">Unlock Your Potential as a Fullstack Developer</h1>
        <p className="text-lg text-gray-700 mb-6">
          Join our Fullstack Development Program and become proficient in building robust, scalable, and user-friendly web applications!
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Why Fullstack Development?</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>High demand for fullstack developers across industries</li>
          <li>Competitive salaries and benefits</li>
          <li>Opportunities for entrepreneurship and innovation</li>
          <li>Create complex web applications from scratch</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Fullstack Development Program</h2>
        <p className="text-gray-700 mb-6">
          Comprehensive curriculum covering:
        </p>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Front-end development (HTML, CSS, JavaScript, React)</li>
          <li>Back-end development (Node.js, Python, Ruby)</li>
          <li>Database management (MySQL, MongoDB)</li>
          <li>Agile methodologies and version control (Git)</li>
          <li>Emerging trends: AI, IoT, and more</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Fullstack Training Roadmap</h2>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 1: Foundations (3 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Introduction to Fullstack Development</li>
          <li>Front-end Development (HTML, CSS, JavaScript)</li>
          <li>Back-end Development (Node.js, Python)</li>
          <li>Database Fundamentals (MySQL, MongoDB)</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 2: Intermediate (6 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Advanced Front-end Development (React, Angular)</li>
          <li>Advanced Back-end Development (Express, Django)</li>
          <li>API Design and Development</li>
          <li>Testing and Debugging</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 3: Advanced (9 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Advanced API Security</li>
          <li>Cloud Computing (AWS, Azure)</li>
          <li>DevOps and Continuous Integration</li>
          <li>Emerging Trends (AI, ML, IoT)</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 4: Specialization (3 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Choose from: Web Development, Mobile App Development, or Enterprise Software Development</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Certifications</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Certified Fullstack Developer (CFD)</li>
          <li>Certified Web Developer (CWD)</li>
          <li>Certified JavaScript Developer (CJD)</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Why Choose Our Program?</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Industry expert instructors</li>
          <li>Hands-on training and projects</li>
          <li>Flexible learning options (online, offline)</li>
          <li>Career support and placement assistance</li>
          <li>Access to fullstack lab and equipment</li>
        </ul>

        <div className="mt-8 text-center">
          <p className="text-lg font-semibold text-gray-800">Join the Fullstack Revolution!</p>
          <p className="text-gray-700 mb-2">Contact us to learn more and enroll today.</p>
          <p className="text-gray-700">
            <strong>Email:</strong> fullstack@techeraafrica.com <br />
            <strong>Phone:</strong> 080 2263 2222
          </p>
          <a
            href="/brochure"
            className="mt-4 inline-block bg-blue-600 text-white font-semibold py-2 px-6 rounded-md shadow hover:bg-blue-700"
          >
            Download Our Brochure
          </a>
        </div>
      </div>
    </div>
    </div>
  )
}

export default FullStack